<template>
  <div :class="$style.error">
    <!-- 主要内容 -->
    <div :class="$style.content">
      <!-- 404数字 -->
      <div :class="$style.errorCode">
        <span :class="$style.number">4</span>
        <span :class="$style.number">0</span>
        <span :class="$style.number">4</span>
      </div>

      <!-- 错误信息 -->
      <div :class="$style.message">
        <h1 :class="$style.title">
          {{ error.statusCode === 404 ? '页面未找到' : '页面错误' }}
        </h1>
        <p :class="$style.description">
          {{
            error.statusCode === 404
              ? '抱歉，您访问的页面不存在或已被移除'
              : error.message || '页面出现了一些问题，请稍后重试'
          }}
        </p>
      </div>

      <!-- 操作按钮 -->
      <div :class="$style.actions">
        <nuxt-link :class="$style.btnPrimary" to="/">
          返回首页
        </nuxt-link>
        <button
          v-if="error.statusCode !== 404"
          :class="$style.btnPrimary"
          @click="$router.go(0)"
        >
          刷新页面
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 错误页面组件
 * 简洁现代的404页面设计
 */
export default {
  name: 'ErrorPage',
  layout: 'blank',
  props: {
    error: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    /**
     * 返回上一页
     * 如果浏览器历史记录为空，则跳转到首页
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
  },
}
</script>

<style lang="less" module>
/**
 * 错误页面样式
 * 简洁现代的设计风格
 */

.error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #fafbfc;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
}

// 主要内容
.content {
  text-align: center;
  max-width: 8rem;
  padding: 0.3rem;
  position: relative;
  z-index: 2;
}

// 404数字 - 简洁风格
.errorCode {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.3rem;
  gap: 0.15rem;
}

.number {
  display: inline-block;
  font-size: 2.5rem;
  font-weight: 300;
  color: #adb5bd;
  letter-spacing: 0.05rem;
  position: relative;
  animation: bounce 2s ease-in-out infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
}

// 错误信息
.message {
  margin-bottom: 0.4rem;
}

.title {
  font-size: 0.4rem;
  font-weight: 600;
  margin-bottom: 0.15rem;
  color: #212529;
}

.description {
  font-size: 0.26rem;
  color: #6c757d;
  line-height: 1.6;
  margin: 0;
  max-width: 5rem;
  margin-left: auto;
  margin-right: auto;
}

// 操作按钮 - 简洁风格
.actions {
  display: flex;
  justify-content: center;
  gap: 0.15rem;
  margin-bottom: 0.3rem;
  flex-wrap: wrap;
}

.btnPrimary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
  padding: 0.2rem 0.4rem;
  border: 0.01rem solid #dee2e6;
  border-radius: 0.06rem;
  font-size: 0.2rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 1.2rem;
  background: transparent;
  color: #6c757d;

  &:hover {
    background: #f8f9fa;
    color: #495057;
    border-color: #ced4da;
  }

  &:active {
    background: #e9ecef;
  }
}

// 动画效果
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-0.1rem);
  }
  60% {
    transform: translateY(-0.05rem);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .content {
    padding: 0.08rem;
    max-width: 98%;
  }

  .errorCode {
    margin-bottom: 0.5rem;
    gap: 0.2rem;
  }

  .number {
    font-size: 6.7rem;
  }

  .message {
    margin-bottom: 0.6rem;
  }

  .title {
    font-size: 0.93rem;
    margin-bottom: 0.25rem;
  }

  .description {
    font-size: 0.67rem;
    max-width: 100%;
    line-height: 1.8;
  }

  .actions {
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
    margin-bottom: 0.4rem;
  }

  .btnPrimary {
    width: 6.7rem;
    padding: 0.33rem 0.67rem;
    font-size: 0.67rem;
    min-width: 5.3rem;
  }
}
</style>
